import { BaseConfig } from '../base-config.interface';

export const config: BaseConfig = {
  mutuelleCode: 'MIE',
  title: 'MIE - Espace Entreprise - ',
  address: [
    'Immeuble le Péricentre',
    '16 Avenue Louison Bobet',
    'CS 60005',
    '94132 Fontenay-sous-Bois Cedex',
  ],
  phone: '01 43 96 74 10',
  email: 'collectif@mutuelle-mie.fr',
  contactHours:
    'Du lundi au jeudi de 8h30 à 17h30 (vendredi 17h00) sans interruption.',
  logoFilename: 'logo.svg',
  config: {
    interface: {
      hideRequestAccess: true,
      contactAllowAttachments: true,
    },
    memberDetails: {
      showBeneficiaires: true,
      showBeneficiaryManagement: false,
      panels: {
        contract: true,
        informations: false,
        documents: true,
      },
      showEmails: false,
      showCotisations: false,
      showDocuments: false,
      showTeletransmission: false,
      showCaisse: false,
    },
    memberList: {
      showPortabilite: false,
      filterStatusToExclude: ['future', 'nd', 'no-effect', 'portability'],
    },
    memberCreate: {
      showRank: false,
      documentRequirements: {
        bulletinAdhesion: false,
        ribPrestationsObligatoires: false,
        ribCotisationsOptionelles: false,
        attestationSecuriteSociale: false,
      },
    },
    memberActions: {
      showBatchImport: false,
      showRadiation: true,
    },
  },
};
